// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.workflow-section {
    padding: 1.5rem;
    background-color: #f8f6f1;
}

.workflow-header h2 {
    font-size: 1.4rem;
    color: #222;
    margin-bottom: 0.3rem;
}

.workflow-header p {
    color: #555;
    font-size: 0.9rem;
    margin-bottom: 1rem;
}

.workflow-filters {
    margin-bottom: 1.25rem;
}

.filter-group {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 0.5rem;
    margin-bottom: 0.6rem;
    font-size: 0.9rem;
    color: #222;
}

.filter-button {
    padding: 0.35rem 0.75rem;
    font-size: 0.85rem;
    border: 1px solid #bbb;
    border-radius: 5px;
    background-color: #fff;
    cursor: pointer;
    transition: 0.2s ease-in-out;
    color:#000000;
}

    .filter-button:hover {
        background-color: #eee;
    }

    .filter-button.active {
        background-color: #2e2e2e;
        color: #fff;
    }

.workflow-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
    gap: 1rem;
}

.workflow-card {
    background-color: #ffffff;
    padding: 1rem;
    border-radius: 8px;
    border-left: 4px solid #ccc;
    box-shadow: 0 2px 5px rgba(0,0,0,0.05);
}

    .workflow-card h3 {
        font-size: 1.1rem;
        margin-bottom: 0.6rem;
        color: #1a1a1a;
        border-bottom: 1px dashed #ccc;
        padding-bottom: 0.3rem;
    }

.agency-box {
    padding: 0.6rem 0.8rem;
    border-radius: 6px;
    margin-bottom: 0.6rem;
    box-shadow: inset 0 0 0 1px #ddd;
    background-color: #fefefe;
}

.agency-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: 600;
    color: #333;
}

.agency-title {
    margin-left: 0.5rem;
}

.status {
    display: flex;
    align-items: center;
}

.ai-note {
    font-size: 0.82rem;
    color: #333;
    padding-left: 1.5rem;
    margin-top: 0.3rem;
}

/* Status-specific background */
.agency-box.cleared {
    background-color: #e6f5ec;
    border-left: 4px solid #2e7d32;
}

.agency-box.processing {
    background-color: #fffbe6;
    border-left: 4px solid #fbc02d;
}

.agency-box.flagged {
    background-color: #fdecea;
    border-left: 4px solid #d32f2f;
}
.workflow-title {
    display: flex;
    align-items: center;
    margin-bottom: 0.2rem;
}

.workflow-description {
    background-color: #fff3e0;
    padding: 0.6rem 1rem;
    font-size: 0.92rem;
    border-left: 4px solid #ff9800;
    border-radius: 6px;
    color: #333;
    margin-bottom: 1rem;
}

.ai-note-block {
    margin-top: 0.4rem;
    padding: 0.6rem 0.75rem;
    font-size: 0.85rem;
    border-radius: 6px;
    box-shadow: inset 0 0 0 1px #e0e0e0;
    background-color: #fdf6e7;
}

    .ai-note-block.flagged {
        background-color: #ffe2e2;
        border-left: 4px solid #d32f2f;
    }

    .ai-note-block.processing {
        background-color: #fff9db;
        border-left: 4px solid #fbc02d;
    }

    .ai-note-block.cleared {
        background-color: #e5f4ea;
        border-left: 4px solid #2e7d32;
    }
`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/LiveWorkflowOverview.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,WAAW;IACX,qBAAqB;IACrB,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,wBAAwB;IACxB,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;IACf,4BAA4B;IAC5B,aAAa;AACjB;;IAEI;QACI,sBAAsB;IAC1B;;IAEA;QACI,yBAAyB;QACzB,WAAW;IACf;;AAEJ;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,2BAA2B;IAC3B,sCAAsC;AAC1C;;IAEI;QACI,iBAAiB;QACjB,qBAAqB;QACrB,cAAc;QACd,8BAA8B;QAC9B,sBAAsB;IAC1B;;AAEJ;IACI,sBAAsB;IACtB,kBAAkB;IAClB,qBAAqB;IACrB,gCAAgC;IAChC,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA,+BAA+B;AAC/B;IACI,yBAAyB;IACzB,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;IACzB,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;IACzB,8BAA8B;AAClC;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,oBAAoB;IACpB,kBAAkB;IAClB,8BAA8B;IAC9B,kBAAkB;IAClB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;IAClB,mCAAmC;IACnC,yBAAyB;AAC7B;;IAEI;QACI,yBAAyB;QACzB,8BAA8B;IAClC;;IAEA;QACI,yBAAyB;QACzB,8BAA8B;IAClC;;IAEA;QACI,yBAAyB;QACzB,8BAA8B;IAClC","sourcesContent":[".workflow-section {\n    padding: 1.5rem;\n    background-color: #f8f6f1;\n}\n\n.workflow-header h2 {\n    font-size: 1.4rem;\n    color: #222;\n    margin-bottom: 0.3rem;\n}\n\n.workflow-header p {\n    color: #555;\n    font-size: 0.9rem;\n    margin-bottom: 1rem;\n}\n\n.workflow-filters {\n    margin-bottom: 1.25rem;\n}\n\n.filter-group {\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 0.5rem;\n    margin-bottom: 0.6rem;\n    font-size: 0.9rem;\n    color: #222;\n}\n\n.filter-button {\n    padding: 0.35rem 0.75rem;\n    font-size: 0.85rem;\n    border: 1px solid #bbb;\n    border-radius: 5px;\n    background-color: #fff;\n    cursor: pointer;\n    transition: 0.2s ease-in-out;\n    color:#000000;\n}\n\n    .filter-button:hover {\n        background-color: #eee;\n    }\n\n    .filter-button.active {\n        background-color: #2e2e2e;\n        color: #fff;\n    }\n\n.workflow-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));\n    gap: 1rem;\n}\n\n.workflow-card {\n    background-color: #ffffff;\n    padding: 1rem;\n    border-radius: 8px;\n    border-left: 4px solid #ccc;\n    box-shadow: 0 2px 5px rgba(0,0,0,0.05);\n}\n\n    .workflow-card h3 {\n        font-size: 1.1rem;\n        margin-bottom: 0.6rem;\n        color: #1a1a1a;\n        border-bottom: 1px dashed #ccc;\n        padding-bottom: 0.3rem;\n    }\n\n.agency-box {\n    padding: 0.6rem 0.8rem;\n    border-radius: 6px;\n    margin-bottom: 0.6rem;\n    box-shadow: inset 0 0 0 1px #ddd;\n    background-color: #fefefe;\n}\n\n.agency-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    font-weight: 600;\n    color: #333;\n}\n\n.agency-title {\n    margin-left: 0.5rem;\n}\n\n.status {\n    display: flex;\n    align-items: center;\n}\n\n.ai-note {\n    font-size: 0.82rem;\n    color: #333;\n    padding-left: 1.5rem;\n    margin-top: 0.3rem;\n}\n\n/* Status-specific background */\n.agency-box.cleared {\n    background-color: #e6f5ec;\n    border-left: 4px solid #2e7d32;\n}\n\n.agency-box.processing {\n    background-color: #fffbe6;\n    border-left: 4px solid #fbc02d;\n}\n\n.agency-box.flagged {\n    background-color: #fdecea;\n    border-left: 4px solid #d32f2f;\n}\n.workflow-title {\n    display: flex;\n    align-items: center;\n    margin-bottom: 0.2rem;\n}\n\n.workflow-description {\n    background-color: #fff3e0;\n    padding: 0.6rem 1rem;\n    font-size: 0.92rem;\n    border-left: 4px solid #ff9800;\n    border-radius: 6px;\n    color: #333;\n    margin-bottom: 1rem;\n}\n\n.ai-note-block {\n    margin-top: 0.4rem;\n    padding: 0.6rem 0.75rem;\n    font-size: 0.85rem;\n    border-radius: 6px;\n    box-shadow: inset 0 0 0 1px #e0e0e0;\n    background-color: #fdf6e7;\n}\n\n    .ai-note-block.flagged {\n        background-color: #ffe2e2;\n        border-left: 4px solid #d32f2f;\n    }\n\n    .ai-note-block.processing {\n        background-color: #fff9db;\n        border-left: 4px solid #fbc02d;\n    }\n\n    .ai-note-block.cleared {\n        background-color: #e5f4ea;\n        border-left: 4px solid #2e7d32;\n    }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
